import { useEffect, useState } from 'react';

// Lower bound for year probing. Conferences before this don't use the
// per-year CSV pair convention, so there's nothing to discover before it.
const MIN_YEAR = 2018;

const exists = (url) =>
  fetch(url, { method: 'HEAD' }).then((res) => res.ok).catch(() => false);

// Dynamically finds every year that has BOTH `${year}.csv` and
// `${year}-authors.csv` published under PUBLIC_URL ("the couple"), without
// requiring any hardcoded list or rebuild when a new year is added.
export const useDiscoveredYears = () => {
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const maxYear = new Date().getFullYear() + 1;
    const candidates = [];
    for (let y = maxYear; y >= MIN_YEAR; y--) candidates.push(y);

    Promise.all(
      candidates.map((year) =>
        Promise.all([
          exists(`${process.env.PUBLIC_URL}/${year}.csv`),
          exists(`${process.env.PUBLIC_URL}/${year}-authors.csv`),
        ]).then(([hasContent, hasAuthors]) => (hasContent && hasAuthors ? year : null))
      )
    ).then((results) => {
      if (cancelled) return;
      const found = results.filter((y) => y !== null).sort((a, b) => b - a);
      setYears(found);
      setLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return { years, loading };
};
